import { render } from "./ViewStudentDTRDialog.vue?vue&type=template&id=3e0c7198&scoped=true"
import script from "./ViewStudentDTRDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentDTRDialog.vue?vue&type=script&lang=js"

import "./ViewStudentDTRDialog.vue?vue&type=style&index=0&id=3e0c7198&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0c7198"]])

export default __exports__